import $http from './http.service';
import {
  URL__AUTH_PASSWORD_FORGOT,
  URL__AUTH_LOGIN,
  URL__AUTH_PASSWORD_RESET,
} from '@/config/config';
import { Authentication, User, LoginOptions, Paging } from '@/store/models';
import jwtService from '@/services/common/jwt.service';
import authModule from '@/store/modules/common/auth.module';

export class AuthService {
  public async login(userSubmit: LoginOptions): Promise<Authentication> {
    const response = await $http.post(URL__AUTH_LOGIN, userSubmit);
    const authentication = response.data.data as Authentication;
    if (authentication) {
      await Promise.all([
        jwtService.saveToken(authentication.Authorization),
        jwtService.saveUser(authentication.admin)
      ]);
    }
    return authentication;
  }

  public async logout() {
    return await $http.patch(`admins/${authModule.user?.id}/logout`);
  }

  public async forgotPassword(email: string) {
    return await $http.post(URL__AUTH_PASSWORD_FORGOT, { email });
  }

  public async resetPassword(payload: { new_password: string; token: string }) {
    return await $http.post(URL__AUTH_PASSWORD_RESET, payload);
  }

  public async changePassword(payload: {
    currentPassword: string;
    newPassword: string;
  }) {
    return await $http.put(`/admins/${authModule.user?.id}/password`, payload);
  }

  public async changeAvatar(file: File) {
    const formData = new FormData();
    const user = await jwtService.getUser();
    formData.append('profilePicture', file, file.name);
    const response = await $http.postWithFormData(
      `/admins/${user.id}/profile-picture`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  }

  public async getAdminInfo() {
    const currentUser = await jwtService.getUser();
    const response = await $http.query(`/admins/${currentUser.id}`);
    return response.data.data as User;
    return null;
  }

  public async updateAdminInfo(user: User) {
    const currentUser = await jwtService.getUser();
    return await $http.put(`/admins/${currentUser.id}`, {
      firstName: user.firstName,
      lastName: user.lastName,
      role: user.role,
      email: user.email,
      companyName: user.companyName
    });
  }
}

const authService = new AuthService();
export default authService;
